<card>
    <div class="card-header-content">
        <span *ngIf="nameLists.length < 2"> {{ wording.namelist.name }} </span>
        <span *ngIf="nameLists.length > 1"> {{ wording.namelist.names }}</span>
        <span class="spacer"></span>
        <btn *ngIf="nameLists.length > 1"
             [label]="Yii.t('wui-skn-js','Tout Envoyer')"
             type="actionDo"
             (click)="clickOnSendButtons()">
            <span class="icon">
                <fa-icon [icon]="iconSendPlane"></fa-icon>
            </span>
        </btn>
    </div>

    <div class="card-body-content">
        <notification *ngIf="errorNotification.active"
                      [type]="errorNotification.type">{{errorNotification.message}}</notification>
        <div *ngFor="let nameList of (nameLists); let i = index">
            <list type="travellersynchronyme"
                  [list]="nameList.traveller"
                  (removeItem)="removePax($event, i)"
                  (showItemEvent)="showTnr($event)">
                <span class="list-header">
                    <div>
                        <div>
                            <ng-container *ngIf="isString( getName( nameList ) )">
                                {{ getName(nameList) }}
                                <ng-container *ngTemplateOutlet="details"></ng-container>
                            </ng-container>
                            <ng-container *ngIf="!isString( getName( nameList ))">
                                {{getWording(nameList)}}
                                <ng-container *ngTemplateOutlet="details"></ng-container>
                                <ng-container *ngFor="let nl of getFiles( nameList ); let l=last">
                                    <a [href]="nl.url" download>{{ nl.file }}</a>
                                    <ng-container *ngIf="!l">, </ng-container>
                                </ng-container>
                            </ng-container>
                            <ng-template #details>
                                <div class="namelistDetails">
                                    <span *ngIf="nameList.journey.carrier.code || nameList.journey.carrier">
                                        {{ nameList.journey.carrier.code ? nameList.journey.carrier.code : nameList.journey.carrier }}
                                    </span>
                                    <span *ngIf="nameList.journey.direction">{{ nameList.journey.direction === 'OneWay' ? 'A' : 'AR'}}</span>
                                    <span *ngIf="nameList.journey?.from?.code || nameList.journey?.to?.code">
                                        {{ nameList.journey?.from?.code}}→{{ nameList.journey?.to?.code }}</span>
                                    <span *ngIf="nameList.journey?.id || nameList.journey?.id">
                                        - {{ nameList.journey?.id}}</span>
                                    <div *ngIf="nameList.journey.begin">
                                        A : {{ nameList.journey.begin | date }}
                                    </div>
                                    <div *ngIf="nameList.journey.end">
                                        R : {{ nameList.journey.end | date }}
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                        <div>
                            <ng-container *ngIf="nameList.stock">
                            <span [class.warning]="nameList.stock.Purchased.remaining === 0">( {{ getSold(nameList.stock.Purchased) }}
                                / {{ nameList.stock.Purchased.quantity }} )</span>
                        </ng-container>

                        </div>
                    </div>

                    <div>
                        <btn
                                type="actionDo"
                                (click)="addPax( i )"
                                *ngIf="showAddPax( nameList )">
                            <span class="icon">
                                <fa-icon [icon]="iconUserPlus"></fa-icon>
                            </span>
                        </btn>

                        <btn
                                type="actionDo"
                                class="sendButton"
                                (onClick)="updateJourney( i )"
                                *ngIf="((isJourney(nameList) && nameList.created && countAddedPax( i ) > 0) || nameList.booking) && bookingJourney">
                            <span class="icon">
                                <fa-icon [icon]="iconSendPlane"></fa-icon>
                            </span>
                        </btn>
                        <btn
                                type="actionDo"
                                class="sendButton"
                                (click)="updatePnr( i )"
                                *ngIf="isJourney(nameList) && !nameList.created && countAddedPax( i ) > 0 || updatedPax">
                            <span class="icon">
                                <fa-icon [icon]="iconSendPlane"></fa-icon>
                            </span>
                        </btn>
                        <btn
                                type="actionDo"
                                class="sendButton"
                                (click)="createPnr( i )"
                                *ngIf="((isJourney(nameList) && nameList.created && countAddedPax( i ) > 0) || nameList.booking) && !bookingJourney">
                            <span class="icon">
                                <fa-icon [icon]="iconSendPlane"></fa-icon>
                            </span>
                        </btn>
                        <btn
                                type="actionDo"
                                class="sendButton"
                                (click)="patchPnrAir( i )"
                                *ngIf="(!isJourney(nameList) && countAddedPax( i ) > 0)">
                            <span class="icon">
                                <fa-icon [icon]="iconSendPlane"></fa-icon>
                            </span>
                        </btn>
                        <btn
                                type="actionUndo"
                                (click)="removePnrList(i)">
                            <span class="icon">
                                <fa-icon [icon]="iconTimes"></fa-icon>
                            </span>
                        </btn>
                    </div>
                </span>
                <span class="list-notification">
                    <loader
                            *ngIf="actionStatus.pending.isCurrentStatus &&
                            actionStatus.pending.index === i"
                            [message]="getApiLabels('pending', actionStatus.pending.type)">
                    </loader>
                    <notification
                            *ngIf="actionStatus.error.isCurrentStatus &&
                             actionStatus.error.index === i"
                            type="error"
                            [showCloseButton]="true"
                            (onClose)="changeActionStatus( 'error', { isCurrentStatus : false });">
                        {{ getApiLabels('error', actionStatus.error.type) }}
                    </notification>
                    <notification
                            *ngIf="actionStatus.success.isCurrentStatus &&
                             actionStatus.success.index === i"
                            type="success"
                            [showCloseButton]="true"
                            (onClose)="changeActionStatus( 'success', { isCurrentStatus : false });">
                        {{ getApiLabels('success', actionStatus.success.type) }}
                    </notification>
                </span>
            </list>

        </div>


    </div>
    <div class="card-footer-content">
        <div class="colored" *ngIf="f_showNewNamelistButton">
            <btn type="actionDo"
                 [label]="Yii.t( 'wui-skn-js', 'Ajouter une nameList' )"
                 *ngIf="!f_showForm && isSelectedPax() && canCreateJourneyPermission"
                 (click)="f_showForm = !f_showForm; inputPnr = ''; actionName=''">
                <span class="icon">
                    <fa-icon [icon]="iconPlus"></fa-icon>
                </span>
            </btn>

            <btn type="actionDo"
                 [label]="Yii.t( 'wui-skn-js', 'Ajouter une nameList' )"
                 *ngIf="!f_showForm && !isSelectedPax() && canCreateJourneyPermission"
                 (click)="f_showForm = !f_showForm; inputPnr = ''; actionName='usePnr'">
                <span class="icon">
                    <fa-icon [icon]="iconPlus"></fa-icon>
                </span>
            </btn>

            <form *ngIf="f_showForm"
                  (submit)="onFormSubmit()">

                <select class="inPlace" [(ngModel)]="actionName" name="actionName">
                    <ng-container *ngIf="!isSelectedPax()">
                        <option value="usePnr" selected>{{Yii.t('wui-skn-js', 'Utiliser un PNR Existant')}}</option>
                    </ng-container>
                    <ng-container *ngIf="isSelectedPax()">
                        <option value="" disabled>{{Yii.t('wui-skn-js', 'Choisir une action')}}</option>
                        <option value="createPnrPassive">{{Yii.t('wui-skn-js', 'Créer un PNR Passif')}}</option>
                        <option value="usePnr">{{Yii.t('wui-skn-js', 'Utiliser un PNR Existant')}}</option>
                        <option *ngFor="let namelist of nameListsConfig" [ngValue]="namelist">
                            {{completeLabel(uiLabels.create, namelist.wording.long)}}
                        </option>
                    </ng-container>
                </select>

                <input type="text"
                       [(ngModel)]="inputPnr"
                       name="inputPnr"
                       [placeholder]="Yii.t( 'wui-skn-js', 'Saisir un identifiant' )"
                       class="inPlace inputPnr"
                       *ngIf="startsWith(actionName, 'use')"
                       autofocus
                       #input>

                <input type="number"
                       [(ngModel)]="quantityPnr"
                       name="quantityPnr"
                       autofocus
                       [placeholder]="Yii.t( 'wui-skn-js', 'max' )"
                       class="inPlace inPlaceNumber"
                       min="10"
                       max="99"
                       step="10"
                       *ngIf="actionName === 'createPnrPassive'">

                <btn type="actionDo" label="OK" btnType="submit"
                     *ngIf="!isActionANameList()"></btn>

                <btn type="actionDo" label="OK" btnType="submit"
                     (click)="newPnr(actionName); quantityPnr = ''"
                     *ngIf="isActionANameList()"></btn>


                <btn type="actionUndo"
                     [label]="Yii.t( 'wui-skn-js', 'Annuler' )"
                     (click)="f_showForm = !f_showForm; quantityPnr = ''"></btn>
            </form>
        </div>
        <div *ngFor="let futureNamelist of futureNamelists; let index = index;" class="futureNamelistContainer">
            <ng-container *ngIf="!futureNamelist.done && !hasLinkedPnr(futureNamelist.data)">
                <div class="futureNamelistDetails">
                    <span *ngIf="futureNamelist.data.journey.carrier.code || futureNamelist.data.journey.carrier">
                                        {{ futureNamelist.data.journey.carrier.code ? futureNamelist.data.journey.carrier.code : futureNamelist.data.journey.carrier }}
                                    </span>
                    <span *ngIf="futureNamelist.data.journey.direction">{{ futureNamelist.data.journey.direction === 'OneWay' ? 'A' : 'AR'}}</span>
                    <span *ngIf="futureNamelist.data.journey?.from?.code || futureNamelist.data.journey?.to?.code">
                                        {{ futureNamelist.data.journey?.from?.code}}
                        →{{ futureNamelist.data.journey?.to?.code }}</span>
                    <div *ngIf="futureNamelist.data.journey.begin">
                        A : {{ futureNamelist.data.journey.begin | date }}
                    </div>
                    <div *ngIf="futureNamelist.data.journey.end">
                        R : {{ futureNamelist.data.journey.end | date }}
                    </div>
                    <div *ngIf="futureNamelist.data.stock">
                        <span [class.warning]="futureNamelist.data.stock.Purchased.remaining === 0">
                            ( {{ getSold(futureNamelist.data.stock.Purchased) }}
                            / {{ futureNamelist.data.stock.Purchased.quantity }} )
                        </span>
                    </div>
                </div>
                <form class="futureNamelistForm">

                    <div *ngIf="isSelectedPax()">
                        <select class="inPlace" [(ngModel)]="futureActionName[index]" name="futureActionName">
                            <ng-container *ngIf="!isSelectedPax()">
                                <option value="usePnr"
                                        selected>{{Yii.t('wui-skn-js', 'Utiliser un PNR Existant')}}</option>
                            </ng-container>
                            <ng-container *ngIf="isSelectedPax()">
                                <option value="" disabled>{{Yii.t('wui-skn-js', 'Choisir une action')}}</option>
                                <option value="createPnrPassive">{{Yii.t('wui-skn-js', 'Créer un PNR Passif')}}</option>
                                <option value="usePnr">{{Yii.t('wui-skn-js', 'Utiliser un PNR Existant')}}</option>
                                <option *ngFor="let namelist of nameListsConfig" [ngValue]="namelist">
                                    {{completeLabel(uiLabels.create, namelist.wording.long)}}
                                </option>
                            </ng-container>
                        </select>

                        <input type="text"
                               [(ngModel)]="futureInputPnr[index]"
                               name="futureInputPnr[index]"
                               [placeholder]="Yii.t( 'wui-skn-js', 'Saisir un identifiant' )"
                               class="inPlace inputPnr"
                               *ngIf="startsWith(futureActionName[index], 'use')"
                               autofocus
                               #input>

                        <input type="number"
                               [(ngModel)]="futureQuantityPnr[index]"
                               name="futureQuantityPnr[index]"
                               autofocus
                               [placeholder]="Yii.t( 'wui-skn-js', 'max' )"
                               class="inPlace inPlaceNumber"
                               min="10"
                               max="99"
                               step="10"
                               *ngIf="futureActionName[index] === 'createPnrPassive'">

                        <btn type="actionDo" label="OK" btnType="submit"
                             (click)="onFutureNamelistSubmit(index)"></btn>
                    </div>


                </form>
            </ng-container>
        </div>
        <loader *ngIf="pnrPending" [message]="getApiLabels('pending')"></loader>
        <notification *ngIf="pnrError" type="error" [showCloseButton]="true" (onClose)="pnrError=false">
            {{ pnrErrorMessage }}
        </notification>
    </div>
</card>
